import { useState, useEffect } from 'react';
import axios from 'axios';

import * as Icons from '../../../images/icons/icons_component';

function OperCmitTrnList_popup() {

    const [data, setData] = useState({});
    const [emogList, setEmogList] = useState([]);
    const [atchDta, setAtchDta] = useState([]);
    const sendData = JSON.parse(localStorage.getItem('cmitTrnData')) || {};

    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/trnlst/opercmitOperrsltTrnDetail.do', {
                params: sendData
            });
            setData(response.data);
            console.log(response.data);
            console.log(sendData);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    };

    const [searchParams, setSearchParams] = useState({
        iemId: '',
        detailSn: '',
        operKndCd: '', //구분
        cdNm: '', //위원회(회의)명
        opmtDt: '',//개최일자
        emtInsttCd: '', //기관명
        dcCn: '',//주요내용
        gnrlRm: '', //비고
        oprtnCo: '',//실시회차
        atdrnCo: '',//참석자 수 
    });

    const isUpdate = sendData.flag === 'update';

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSearchParams((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setAtchDta(e.target.files[0]);
    };

    useEffect(() => {
        const fetchHospList = async () => {
            try {
                const response = await axios.get('/trmsapi/trnlst/trmsEmogList.do', {
                    params: {}
                });
                setEmogList(response.data.trnEmogList || []);
            } catch (error) {
                console.error('병원 목록 로딩 중 오류 발생:', error);
            }
        };
        fetchHospList();
        popupData();
    }, []);

    useEffect(() => {
        setSearchParams((prev) => ({
            ...prev,
            iemId: sendData.IEM_ID,
            detailSn: sendData.DETAIL_SN || null,
            operKndCd: data.OPER_KND_CD, //구분
            cdNm: data.CD_NM, //위원회(회의)명
            opmtDt: isUpdate ? data.TR_OPMT_DT : sendData.TR_OPMT_DT,//개최일자
            emtInsttCd: data.EMT_INSTT_CD || sendData.EMOGCODE, //기관명
            dcCn: data.DC_CN,//주요내용
            gnrlRm: data.GNRL_RM || '', //비고
            oprtnCo: data.OPRTN_CO,//실시회차
            atdrnCo: data.ATDRN_CO,//참석자 수 
        }));
        setAtchDta(data.ATCH_DTA);
    }, [data]);


    const del = async () => {
        const confirmMessage = "정말로 삭제하시겠습니까?";
        const confirmed = window.confirm(confirmMessage);

        if (!confirmed) return;

        try {
            const response = await axios.get("/trmsapi/trnlst/opercmitOperrsltTrnDetailDelete.do", {
                params: sendData.DETAIL_SN,
            });
            alert(response.data.resultMessage);
        } catch (error) {
            console.error('데이터 저장 중 오류 발생:', error);
        }
    }

    const save = async () => {
        const requiredFields = [
            { key: 'operKndCd', label: '구분' },
            { key: 'cdNm', label: '위원회명' },
            { key: 'opmtDt', label: '개최일자' },
            { key: 'emtInsttCd', label: '기관명' },
            { key: 'dcCn', label: '주요내용' },
            { key: 'oprtnCo', label: '실시회차' },
            { key: 'atdrnCo', label: '참석자 수' },
        ];
        for (const field of requiredFields) {
            const value = searchParams[field.key];
            if (value === '' || value === null || value === undefined) {
                alert(`${field.label}을(를) 입력(선택)해야합니다.`);
                return;
            }
            if (['oprtnCo', 'atdrnCo'].includes(field.key)) {
                const numValue = Number(value);
                if (numValue < 0) {
                    alert(`${field.label}에 입력할 수 없는 값입니다.`);
                    return;
                }
            }
        }

        const confirmMessage = "저장하시겠습니까?";
        const confirmed = window.confirm(confirmMessage);
        if (!confirmed) return;

        const formData = new FormData();

        Object.entries(searchParams).forEach(([key, value]) => {
            formData.append(key, value);
        });

        if (atchDta) {
            formData.append("atchDta", atchDta);
        }

        formData.append("userId", localStorage.getItem("id"));

        try {
            const response = await axios.post(
                "/trmsapi/trnlst/opercmitOperrsltTrnDetailSave.do",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
            alert(response.data.resultMessage);
        } catch (error) {
            console.error("데이터 저장 중 오류 발생:", error);
        }
    };

    return (
        <div className='popup_container bg_tr_bg'>
            <div className='flex justify-between'>
                <h5 className='sub_title m-0 p-0'>위원회 운영실적</h5>
                <div className='flex gap-1'>
                    {isUpdate && (
                        <button onClick={del} title="삭제" className='search_btn bg_co_black justify-self-end'>
                            <Icons.DeleteCircle16w />삭제
                        </button>
                    )}
                    <button onClick={save} title={isUpdate ? '수정' : '저장'} className='search_btn bg_tr_primary justify-self-end'>
                        <Icons.Save16w />{isUpdate ? '수정' : '저장'}
                    </button>
                </div>
            </div>
            <div className='com-search tr_pop_th_bg border-l border-r'>
                <form>
                    <hr className='border-t-2 mr-1-1 tr_border_soft' />
                    <table>
                        <colgroup>
                            <col width="15%" />
                            <col width="35%" />
                            <col width="15%" />
                            <col width="35%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>연번</th>
                                <td>{sendData.IEM_ID || ''}</td>
                                <th>구분</th>
                                <td>
                                    <select
                                        id="operKndCd"
                                        name="operKndCd"
                                        className='w-full'
                                        value={searchParams.operKndCd}
                                        onChange={handleChange}
                                    >
                                        <option value="">선택</option>
                                        <option value="TN01">운영위원회</option>
                                        <option value="TN02">질관리 위원회</option>
                                        <option value="TN03">질 관리 활동 실적</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>안건명</th>
                                <td>
                                    <input
                                        type="text"
                                        id="cdNm"
                                        name="cdNm"
                                        className='input_style'
                                        value={searchParams.cdNm}
                                        onChange={handleChange}
                                    />
                                </td>
                                <th>증빙자료</th>
                                <td>
                                    <input
                                        type="file"
                                        id="atchDta"
                                        name="atchDta"
                                        onChange={handleFileChange} />
                                </td>
                            </tr>
                            <tr>
                                <th>개최일시</th>
                                <td>
                                    <input
                                        type="date"
                                        name="opmtDt"
                                        id="opmtDt"
                                        value={searchParams.opmtDt}
                                        onChange={handleChange}
                                    />
                                </td>
                                <th>기관명</th>
                                <td>
                                    <select
                                        name="emtInsttCd"
                                        id="emtInsttCd"
                                        className='w-full'
                                        value={searchParams.emtInsttCd}
                                        onChange={handleChange}
                                    >
                                        <option value="">선택</option>
                                        {emogList.map((hosp) => (
                                            <option key={hosp.EMOGCODE} value={hosp.EMOGCODE}>
                                                {hosp.EMOGDESC}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>

                            <tr>
                                <th>주요내용</th>
                                <td colSpan="3">
                                    <textarea
                                        id="dcCn"
                                        name="dcCn"
                                        rows="10"
                                        className='textarea_style'
                                        value={searchParams.dcCn}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <th>비고</th>
                                <td colSpan="3">
                                    <textarea
                                        id="gnrlRm"
                                        name="gnrlRm"
                                        rows="10"
                                        className='textarea_style'
                                        value={searchParams.gnrlRm}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <th>실시회차</th>
                                <td>
                                    <input
                                        type="number"
                                        id="oprtnCo"
                                        name="oprtnCo"
                                        className='input_style'
                                        value={searchParams.oprtnCo}
                                        onChange={handleChange}
                                    />
                                </td>
                                <th>참석자 수</th>
                                <td>
                                    <input
                                        type="number"
                                        id="atdrnCo"
                                        name="atdrnCo"
                                        className='input_style'
                                        value={searchParams.atdrnCo}
                                        onChange={handleChange}
                                    />
                                </td>
                            </tr>
                            {isUpdate && (
                                <tr>
                                    <th>생성일시</th>
                                    <td>{data.TR_CREAT_DT}</td>
                                    <th>수정일시</th>
                                    <td>{data.TR_UPDT_DT || ''}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </form>
            </div>
        </div >
    );
}

export default OperCmitTrnList_popup;
